<template>
  <div class="footerbar">
    <div class="footbox">
      <div class="footboximg">
        <img src="~assets/images/footer/more1.png" alt="" />
      </div>　
      <div class="footbar">
        <div class="footerli" >关于我们</div>
        <!-- <div class="footerpaddig">|</div>
        <div class="footerli" v-on:click="gotoRankPage()">赛事日历</div>
        <div class="footerpaddig">|</div>
        <div class="footerli" v-on:click="gotoMyPage()">场地设置</div>
        <div class="footerpaddig">|</div>
        <div class="footerli" v-on:click="gotoSetPage()">教练团队</div>
        <div class="footerpaddig">|</div>
        <div class="footerli" v-on:click="gotoSetPage()">会员团队</div> -->
      </div>　
      <div class="footertext">
        备案号：京ICP备2025123172号
      </div>
    </div>
    
    <!-- <div class="footerli hover" v-on:click="gotoHomePage()" v-if="hover==1">首页 -->
  </div>
</template>

<script>
export default {
  name: "MyFooter",
  // props: {
  //   'hover':{
  //   type: Number,
  //   required : true
  //   }
  // },
  data() {
    return {};
  },
  components: {},
  computed: {},
  mounted: function () {
    console.log();
  },
  methods: {
    gotoHomePage: function () {
      this.$router.push({
        name: "Index",
      });
    },
    gotoMyPage: function () {
      this.$router.push({
        name: "Index",
      });
    },
    gotoSetPage: function () {
      this.$router.push({
        name: "Index",
      });
    },
    gotoRankPage: function () {
      this.$router.push({
        name: "Index",
      });
    },
  },
};
</script>

<style scoped>
.footbox {
  width: 100vw;
  height: 100%;
  background-color: #000;
}

.footboximg {
  width: 100vw;
  height: 10vw;
  text-align: center;
  position: relative;
  top: 5vw;
}

.footboximg img {
  width: 45%;
  height: auto;
}

.footbar {
  width: 100vw;
  height: 10vw;
  text-align: center;
  position: relative;
  top: 0vw;
}

.footerbar .footerli {
  display: inline-block;
  position: relative;
  bottom: 1px;
  font-size: 18px;
  width: 8.5vw;
  text-align: center;
  top: 18px;
}
.footerbar .footerpaddig {
  display: inline-block;
  font-size: 16px;
  top: 18px;
  position: relative;
}

.footertext{
  width: 100vw;
  height: 10vw;
  text-align: center;
  position: relative;
  top: 0vw;
   font-size: 18px;
}


.topbar .titleimg {
  width: 100vw;
  height: 5vw;
  margin: 0 auto;
}

.topbar .titleimg img {
  width: 100%;
  height: auto;
}

.titlebar {
  margin-top: 1vw;
  width: 100vw;
  height: 5vw;
  display: flex;
  /* justify-content: space-between; */
  /* 让两个 div 之间有间距 */
  /* gap: 20px; */
  /* 可选：设置两个 div 之间的间距 */
  color: #fff;
}

.titlebar .logoimg {
  width: 27vw;
  height: 100%;
  /* position: relative; */
  margin-left: 3vw;
  display: flex;
  margin-top: 1vw;
}

.titlebar .logoimg img {
  width: 15vw;
  height: 5vw;
}

.titlebar .titlenav {
  width: 38vw;
  height: 100%;
  display: flex;
  /* flex-direction: column; 
  align-items: center; 
  border: 1px solid #ccc; 
  padding: 10px; */
  justify-content: space-around;
  /* 文字之间均匀分布 */
  align-items: center;
  /* 垂直居中对齐 */
  font-weight: bolder;
  font-size: 1.4vw;
}

.titlebar .titlenav .navitem {
  /* width: 100%;
    height: 100%; */
  /* display: flex; */
}

.titlebar .navRegitem {
  margin-left: 11.5vw;
  margin-top: 0.5vw;
  width: 13vw;
  height: 4vw;
  display: flex;
  justify-content: space-around;
  align-items: center;
  font-weight: bolder;
  font-size: 1.4vw;
  background-color: #a81f24;
}

.titlebar .personbox {
  margin-left: 1.5vw;
  margin-top: 0.5vw;
  width: 2vw;
  height: 4vw;
  display: flex;
  justify-content: space-around;
  align-items: center;
  /* background-color: #a81f24; */
}

.titlebar .personbox img {
  width: 100%;
  height: auto;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}


</style>


// WEBPACK FOOTER //
// src/components/block/footer.vue